import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';
import { EnumContentType } from '@/constant/enums';

const baseUrl = envConfig.formalServer + "/plat/admin/track/event/"

function baseApi() {
    function insertTrackEvent(data) {
        return Post(baseUrl + "insertTrackEvent", data)
    }

    function insertTrackEventInfoAndParameter(data) {
        return Post(baseUrl + "insertTrackEventInfoAndParameter", data)
    }

    function batchImportTrackEvent(data) {
        return Post(baseUrl + 'batchImportTrackEvent', data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        });
    }

    function deleteTrackEvent(data) {
        return Post(baseUrl + "deleteTrackEvent", data)
    }

    function updateTrackEvent(data) {
        return Post(baseUrl + "updateTrackEvent", data)
    }

    function queryTrackEvent(data) {
        return Post(baseUrl + "queryTrackEvent", data)
    }

    function queryTrackEventDetail(data) {
        return Post(baseUrl + "queryTrackEventDetail", data)
    }

    return {
        insertTrackEvent,
        deleteTrackEvent,
        updateTrackEvent,
        queryTrackEvent,
        queryTrackEventDetail,
        insertTrackEventInfoAndParameter,
        batchImportTrackEvent
    }
}

export const trackEventApi = baseApi()
